import * as React from "react";
import {
  MenuItem,
  TextField,
  Select,
  TableRow,
  TableCell,
  Button,
  FormControl,
} from "@material-ui/core";
import {
  Done as DoneIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
} from "@material-ui/icons";

interface IEditableListItemProps {
  key: any,
  item: any,
  deleteHandler: any,
  editable: boolean,
  directlyEditable: boolean,
  propChangeHandler: any,
  settings: any,
  isNew: boolean,
}

class EditableListItem extends React.PureComponent<IEditableListItemProps, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      editing: this.props.directlyEditable || this.props.isNew,
    };
  }

  public render() {
    const { item, directlyEditable } = this.props;
    const { editing } = this.state;

    const itemKeyValProps = Object.keys(item).map((key) => ({
      key,
      value: item[key],
    }));

    return (
        <React.Fragment>
          <TableRow>
            {itemKeyValProps.map((itemProp: any, index: number) => {
              const settings = this.props.settings[itemProp.key];
              if (!settings) {
                console.error(`No EditableListItem settings could be found for ${itemProp.key}`)
                return <> </>;
              } else {
                return (
                  <TableCell key={index}>
                    {!editing && <span> {itemProp.value} </span>}

                    {editing && settings.type === "text" && (
                      <TextField
                        fullWidth
                        name={itemProp.key}
                        disabled={!!settings.disabled}
                        margin="normal"
                        value={itemProp.value || ''}
                        onChange={(e) =>
                          this.props.propChangeHandler(
                            e.target.name,
                            e.target.value === "" ? null : e.target.value,
                          )
                        }
                        InputLabelProps={{
                          shrink: true,
                        }}
                        autoFocus={index === 0}
                      />
                    )}
                    {editing && settings.type === "number" && (
                      <TextField
                        fullWidth
                        name={itemProp.key}
                        disabled={!!settings.disabled}
                        type="number"
                        margin="normal"
                        value={itemProp.value || ''}
                        onChange={(e) =>
                          this.props.propChangeHandler(
                            e.target.name,
                            Number(e.target.value),
                          )
                        }
                        InputLabelProps={{
                          shrink: true,
                        }}
                        autoFocus={index === 0}
                      />
                    )}
                    {editing && settings.type === "select" && (
                      <FormControl fullWidth margin="normal">
                        <Select
                          fullWidth
                          value={itemProp.value}
                          displayEmpty
                          disabled={!!settings.disabled}
                          onChange={(e) =>
                            this.props.propChangeHandler(
                              e.target.name,
                              e.target.value,
                            )
                          }
                          inputProps={{
                            value: itemProp.value,
                            name: itemProp.key,
                          }}
                          autoFocus={index === 0}
                        >
                          {settings.options.map((option: any, jindex: number) => (
                            <MenuItem value={option.value} key={jindex}>
                              {" "}
                              {option.label}{" "}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )}
                    {editing &&
                      settings.type === "custom" &&
                      settings.renderComponent(itemProp.value, (value: any) =>
                        this.props.propChangeHandler(itemProp.key, value),
                      )}
                  </TableCell>
                );
              }
            }, this)}

            {this.props.editable && (
                <TableCell>
                  {!directlyEditable && (
                      <Button
                          onClick={() =>
                              this.setState({ editing: !this.state.editing })
                          }
                      >
                        {!this.state.editing && <EditIcon />}
                        {this.state.editing && <DoneIcon />}
                      </Button>
                  )}
                  <Button onClick={() => this.props.deleteHandler()}>
                    <DeleteIcon />
                  </Button>
                </TableCell>
            )}
          </TableRow>
        </React.Fragment>
    );
  }
}

export default EditableListItem;



// WEBPACK FOOTER //
// ./src/modules/shared/components/EditableListItem.tsx